import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../../utils/posthogEvents';
import axios from 'axios';
import Cookies from 'js-cookie';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import {
  loginformImg,
  trustPilotRating,
  whiteCheck,
} from '../../assets/images';
import { useDocContext } from '../../context/DocContext';
export default function Login({
  handleShowSignUp,
  setShowLogin,
  onlyLogin,
  disableCaptcha = false,
}) {
  const { register, handleSubmit } = useForm({});
  const { user, setContext } = useDocContext();
  const [triggerSpinner, settriggerSpinner] = useState(false);
  if (user) {
    setShowLogin(false);
    // settriggerSpinner(false);
  }

  const onSubmit = async (data) => {
    settriggerSpinner(true);
    try {
      const { data: user } = await axios.get('https://24doc.b4a.io/login', {
        headers: {
          'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
          'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
          'X-Parse-Revocable-Session': 1,
          'Content-Type': 'application/json',
        },
        params: {
          username: data.email.trim().toLowerCase(),
          password: data.password,
        },
      });

      Cookies.set('sessionToken', user.sessionToken, { expires: 360 });
      setContext((context) => {
        return { ...context, user: user };
      });
      setShowLogin(false);
      toast.success("You've successfully logged in");
    } catch (e) {
      settriggerSpinner(false);
      // See pages/login.js: sign-in exists in three places, each reports.
      captureEvent(PH_DIRECT.LOGIN_FAILED, {
        reason:
          e?.response?.data?.code === 101
            ? 'invalid_credentials'
            : e?.response?.status
            ? `http_${e.response.status}`
            : 'network_error',
      });
      toast.error('Error logging in, Please check your email and password');
    }
  };

  return (
    <main className='modalParent'>
      <div>
        <Container>
          <Row className='modalStyle'>
            <h3 className='loginFormHeadingSmall'>
              Welcome <span className='gradientText'>back</span>
            </h3>
            {/* for the image */}
            <Col xs={12} lg={6} className=' d-flex h-100'>
              <div className='flex-grow-1 position-relative modalImageHeight1'>
                <Image
                  src={loginformImg}
                  layout='fill'
                  objectFit='cover'
                  quality={80}
                  alt='sign-up-image'
                  style={{ borderRadius: '1.25rem' }}
                />
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    zIndex: '2',
                    padding: '1.25rem 1rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    {ImgOverlay.map((item) => (
                      <div
                        key={item.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          columnGap: '6px',
                        }}
                      >
                        <Image
                          src={whiteCheck}
                          width={18}
                          height={18}
                          alt='tick-mark'
                        />
                        <span className='formImgOverlayText'>
                          {item.content}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className='trustPilotRatingImgDiv'>
                    <Image
                      src={trustPilotRating}
                      // width={132}
                      //height={122}
                      layout='fill'
                      objectFit='cover'
                      alt='trust-pilot-rating'
                      quality={80}
                      style={{ borderRadius: '0.75rem' }}
                    />
                  </div>
                </div>
              </div>
            </Col>
            {/* the form */}
            <Col xs={12} lg={6}>
              <div className='loginFormContainer'>
                <Container className=''>
                  <Row className=''>
                    <Col className='p-0'>
                      <Form
                        className='theLoginForm'
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <h3
                          className='loginTitle'
                          style={{ textAlign: 'center' }}
                        >
                          Welcome <span className='gradientText'>back</span>
                        </h3>

                        {/* <div className='py-2' /> */}
                        {/* For the form Inputs */}
                        <div className='theFormInputs'>
                          <Form.Group>
                            <Form.Label className='formInputLabel'>
                              Email
                            </Form.Label>
                            <Form.Control
                              placeholder='johnsmith@gmail.com'
                              {...register('email')}
                              className='formInputLogin'
                            />
                          </Form.Group>

                          {/* <div className='py-2' /> */}
                          <Form.Group>
                            <Form.Label className='formInputLabel'>
                              Password
                            </Form.Label>
                            <Form.Control
                              type='password'
                              placeholder='******************'
                              {...register('password')}
                              className='formInputLogin'
                            />
                          </Form.Group>
                          <Link
                            legacyBehavior={true}
                            href='/forgot-password'
                            passHref
                          >
                            <a
                              className='d-flex justify-content-start'
                              style={{
                                textDecoration: 'underline',
                                color: '#0f0f0f',

                                fontSize: '0.875rem',
                                fontFamily: 'Poppins',
                                fontWeight: '500',
                              }}
                              onClick={() => {
                                captureEvent(PH_DIRECT.CLICK, {
                                  cta: PH_CTA.FORGOT_PASSWORD,
                                  placement: PH_PLACEMENT.LOGIN_MODAL,
                                });
                                setShowLogin(false);
                              }}
                            >
                              Forgot your password?
                            </a>
                          </Link>
                        </div>

                        {/* <div className='py-2' /> */}
                        <button
                          type='submit'
                          className='loginButtonForm d-flex justify-content-center align-items-center'
                        >
                          Login{' '}
                          {triggerSpinner ? (
                            <Spinner
                              variant='light'
                              style={{
                                width: '1.5rem',
                                height: '1.5rem',
                                marginLeft: '.75rem',
                              }}
                            />
                          ) : null}{' '}
                        </button>
                        {onlyLogin == false ? (
                          <p
                            style={{
                              fontSize: '12px',
                              color: 'black',
                              fontFamily: 'Poppins',
                              textAlign: 'center',
                            }}
                          >
                            You don&apos;t have an account?
                            <span
                              style={{
                                fontWeight: '600',

                                fontFamily: 'Poppins',
                              }}
                              onClick={() =>
                                handleShowSignUp(PH_CTA.NO_ACCOUNT_SIGNUP)
                              }
                            >
                              &nbsp;Sign Up
                            </span>
                          </p>
                        ) : null}
                      </Form>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </main>
  );
}

export async function getStaticProps(context) {
  return { props: { layout: 'no-layout' } };
}
const ImgOverlay = [
  { id: 1, content: `Save your progress` },
  { id: 2, content: `Easy Refills` },
  { id: 3, content: `Track your health` },
];
